import { type PropsWithChildren } from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationBottomBar = (props: Props) => {
  const { width: viewportWidth } = useWindowDimensions();

  const contentContainerStyles = [
    styles.contentContainer,
    viewportWidth > 1200 ? styles.contentContainerWide : undefined,
  ];

  return (
    <View>
      {props.withGradient ? (
        <>
          <LinearGradient
            style={styles.gradientContainer}
            pointerEvents="none"
            colors={GRADIENT_COLORS.BACK_LAYER}
          />
          <LinearGradient
            style={styles.gradientContainer}
            pointerEvents="none"
            colors={GRADIENT_COLORS.FRONT_LAYER}
          />
        </>
      ) : null}

      <View style={contentContainerStyles}>{props.children}</View>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const GRADIENT_COLORS = {
  BACK_LAYER: [
    theme.colors.OPACITY.BLACK.TRANSPARENT,
    theme.colors.OPACITY.BLACK.LIGHTEST,
  ] as const,
  FRONT_LAYER: [
    theme.colors.OPACITY.OATMEAL.TRANSPARENT,
    theme.colors.OPACITY.OATMEAL.DARKER,
  ] as const,
};

const GRADIENT_CONTAINER_HEIGHT = 40;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  gradientContainer: {
    position: 'absolute',
    top: -GRADIENT_CONTAINER_HEIGHT,
    right: 0,
    left: 0,
    height: GRADIENT_CONTAINER_HEIGHT,
  },
  contentContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.WHITE,
    paddingHorizontal: theme.spacing['6'],
    paddingVertical: theme.spacing['4'],
    gap: theme.spacing['2'],
    justifyContent: 'space-between',
  },
  contentContainerWide: {
    paddingHorizontal: theme.spacing['10'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  withGradient?: boolean;
}>;
